import { SVG } from '../../SVG'

const PipscLogoCollapsed = ({ style = {}, ...props }) => (
  <SVG
    width='42'
    height='41'
    viewBox='0 0 42 41'
    xmlns='http://www.w3.org/2000/svg'
    style={{ fill: 'var(--primary-color)', ...style }}
    alt='PIPSC Voter Portal Logo'
    {...props}
  >
    <path d='M20.8182 21.9218C24.4384 21.9218 27.3805 19.0068 27.3805 15.4199C27.3805 11.833 24.4384 8.91797 20.8182 8.91797C17.198 8.91797 14.2559 11.833 14.2559 15.4199C14.2559 19.0068 17.198 21.9218 20.8182 21.9218ZM20.8182 12.7866C22.2892 12.7866 23.4759 13.9678 23.4759 15.4199C23.4759 16.872 22.2838 18.0532 20.8182 18.0532C19.3526 18.0532 18.1604 16.872 18.1604 15.4199C18.1604 13.9678 19.3526 12.7866 20.8182 12.7866Z' />
    <path d='M41.5122 20.5677C41.5122 9.20563 32.221 0 20.7588 0C9.29663 0 0 9.20563 0 20.5677C0 27.8011 3.77334 34.1622 9.47709 37.8249V14.3963H9.53178C10.0568 8.67464 14.9184 4.17748 20.8244 4.17748C27.0805 4.17748 32.1718 9.22188 32.1718 15.4204C32.1718 21.6189 27.0805 26.6633 20.8244 26.6633C18.38 26.6633 16.116 25.883 14.2621 24.5772V40.1006C15.5965 40.534 16.991 40.8429 18.4292 41V28.11H23.2142V40.9837C33.5171 39.7809 41.5122 31.1008 41.5122 20.5677Z' />
  </SVG>
)

export default PipscLogoCollapsed
